const errorNotificationDialog = require('../components/errorNotificationDialog');
module.exports = function (err) {
    if ('responseJSON' in err && 'redirectUrl' in err.responseJSON && err.responseJSON.redirectUrl) {
        // リダイレクトURLがあればリダイレクト
        window.location.href = err.responseJSON.redirectUrl;
        return false;
    } else if('responseJSON' in err && 'message' in err.responseJSON && err.responseJSON.message){
        errorNotificationDialog(err.responseJSON.message);
        $.spinner().stop();
        return false;
    }
    return true;
};
